import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-320c28e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-diamond" }, "卡片", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 顾名思义，Border Card UI 是一个基于大量卡片的 UI 框架，所以卡片是它的基础组件之一， 你可以使用卡片来包裹任何内容，也可以叠加多个卡片来实现更复杂的效果。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 卡片是个简单的 UI 元素，可以包含图标、标题等内容，下面是具体的使用方法。 ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "可选参数", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "title"),
    /*#__PURE__*/_createTextVNode(" ：卡片的标题")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "icon"),
    /*#__PURE__*/_createTextVNode(" ：卡片的图标，使用 Font Awesome 名称。如果不填写值（或者是空字符串），将会显示为点前缀。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "@remove"),
    /*#__PURE__*/_createTextVNode(" ：卡片的关闭按钮的回调函数，如果存在将会显示关闭按钮。此选项必须同时存在 "),
    /*#__PURE__*/_createElementVNode("code", null, "title"),
    /*#__PURE__*/_createTextVNode(" 参数。")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "卡片重叠", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 卡片可以叠加在一起，这样可以实现更复杂的效果。在卡片重叠的时候，你可以添加 class 来修改卡片的背景颜色。 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "示例", -1))
const _hoisted_8 = {
  class: "view-space",
  id: "ss-card-code"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("code", null, "ss-card"),
  /*#__PURE__*/_createTextVNode(" 卡片拥有 "),
  /*#__PURE__*/_createElementVNode("code", null, "5px"),
  /*#__PURE__*/_createTextVNode(" 的外边框，这是阴影的预留空间； 在进行元素对齐的时候需要留意。你可以点击关闭按钮移除这个卡片。")
], -1))
const _hoisted_10 = { style: {"display":"flex","align-items":"start"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "color-view" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card font" }, "card + font"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-1 font-1" }, "card-1 + font-1"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-2 font-2" }, "card-2 + font-2")
], -1))
const _hoisted_12 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "但是你不能将作用于内容的 style 样式直接添加在卡片上，套一个 div 或许是个好的选择。", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code card-1" }, [
  /*#__PURE__*/_createElementVNode("code", null, /*#__PURE__*/_toDisplayString('<ss-card\n') + " " + /*#__PURE__*/_toDisplayString('    title="提醒"\n') + " " + /*#__PURE__*/_toDisplayString('    icon="fa-solid fa-circle-info"\n') + " " + /*#__PURE__*/_toDisplayString('    @remove="removeCard">\n') + " " + /*#__PURE__*/_toDisplayString('    <span><code>ss-card</code> 卡片拥有 <code>5px</code> 的外边框，这是阴影的预留空间；\n') + " " + /*#__PURE__*/_toDisplayString(' 在进行元素对齐的时候需要留意。你可以点击关闭按钮移除这个卡片。</span>\n') + " " + /*#__PURE__*/_toDisplayString('</ss-card>\n') + " " + /*#__PURE__*/_toDisplayString('<div style="display: flex;align-items: start;">\n') + " " + /*#__PURE__*/_toDisplayString(' <ss-card title="卡片颜色" icon>\n') + " " + /*#__PURE__*/_toDisplayString(' <div class="color-view">\n') + " " + /*#__PURE__*/_toDisplayString(' <div class="card font">card + font</div>\n') + " " + /*#__PURE__*/_toDisplayString(' <div class="card-1 font-1">card-1 + font-1</div>\n') + " " + /*#__PURE__*/_toDisplayString(' <div class="card-2 font-2">card-2 + font-2</div>\n') + " " + /*#__PURE__*/_toDisplayString(' </div>\n') + " " + /*#__PURE__*/_toDisplayString(' </ss-card>\n') + " " + /*#__PURE__*/_toDisplayString(' <ss-card>\n') + " " + /*#__PURE__*/_toDisplayString(' <div style="display: flex;align-items: center;">\n') + " " + /*#__PURE__*/_toDisplayString(' <font-awesome-icon style="margin-right: 30px;" icon="fa-solid fa-circle-info" />\n') + " " + /*#__PURE__*/_toDisplayString(' <span>但是你不能将 style 样式直接添加在卡片上，套一个 div 或许是个好的选择。</span>\n') + " " + /*#__PURE__*/_toDisplayString(' </div>\n') + " " + /*#__PURE__*/_toDisplayString(' </ss-card>\n') + " " + /*#__PURE__*/_toDisplayString('</div>'))
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-puzzle-piece" }, "表单", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 表单不是一个单独的组件，它是一堆表单组件的集合。由于大部分表单组件都由纯 css 实现，为了防止 doc 累述全都放置在一起。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 大部分表单都不需要使用组件，它已经包含在全局 css 中。具体使用方法可以参考示例。 ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "输入框：ss-input", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 输入框提供了 css 的基本样式和组件的版本。在组件版本中标题样式和卡片用法相同， 输入框值支持使用 "),
  /*#__PURE__*/_createElementVNode("code", null, "value"),
  /*#__PURE__*/_createTextVNode(" 参数传入或使用 "),
  /*#__PURE__*/_createElementVNode("code", null, "v-model"),
  /*#__PURE__*/_createTextVNode(" 进行双向绑定。 ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "示例", -1))
const _hoisted_20 = { class: "form-demo" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "昵称", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "邮箱", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "公开显示邮箱"),
  /*#__PURE__*/_createElementVNode("label", { class: "ss-switch" }, [
    /*#__PURE__*/_createElementVNode("input", { type: "checkbox" }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div")
    ])
  ])
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "密码"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "password",
    class: "ss-input"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "性别"),
  /*#__PURE__*/_createElementVNode("label", { class: "ss-radio" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      name: "f"
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "男"),
  /*#__PURE__*/_createElementVNode("label", { class: "ss-radio" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      name: "f"
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "女"),
  /*#__PURE__*/_createElementVNode("label", { class: "ss-radio" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      name: "f",
      checked: ""
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "其他")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "启用版本"),
  /*#__PURE__*/_createElementVNode("select", { class: "ss-select" }, [
    /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1.0"),
    /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2.0"),
    /*#__PURE__*/_createElementVNode("option", { value: "0" }, "rolling")
  ])
], -1))
const _hoisted_27 = { class: "code card-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-scroll" }, "滚动标签卡", -1))
const _hoisted_29 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "这是个来自 Stapxs QQ Lite 的设置列表风格", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 这是个类似 Bootstrap 的 Scrollspy 组件，虽然没它功能多就是了，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 这个组件曾经被用在设置列表中，适合用于作为一个长文档的目录，或者是一个长列表的目录。 ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "可选参数", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "title"),
    /*#__PURE__*/_createTextVNode(" ：「必填」标签卡列表的标题。需要将它添加在正文中的 H2 标签上，如果存在将会显示在标签卡列表的顶部。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "icon"),
    /*#__PURE__*/_createTextVNode(" ：标签项的图标，使用 Font Awesome 名称。需要将它添加在正文中的 H2 标签上，组件将会自动获取并用于生成列表。")
  ])
], -1))
const _hoisted_34 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("注意，当你不想要显示 H2 的时候，不要使用 "),
  /*#__PURE__*/_createElementVNode("code", null, "display: none"),
  /*#__PURE__*/_createTextVNode("，这样会导致无法正常捕获到它，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 你可以使用 "),
  /*#__PURE__*/_createElementVNode("code", null, "opacity: 0"),
  /*#__PURE__*/_createTextVNode(" 或者 "),
  /*#__PURE__*/_createElementVNode("code", null, "height: 0"),
  /*#__PURE__*/_createTextVNode(" 来隐藏它。")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "示例", -1))
const _hoisted_37 = {
  class: "view-space",
  style: {"height":"40vh"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-expand" }, "卡片1", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "卡片2", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "just-img",
  src: "https://lib.stapxs.cn/download/pic/desktopImg/95018142_p0.png"
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "just-img-a",
  href: "https://www.pixiv.net/artworks/95018142"
}, "* 图片来源，侵权请反馈仓库 issue。", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code card-2" }, [
  /*#__PURE__*/_createElementVNode("code", null, /*#__PURE__*/_toDisplayString(' <bc-scrolltab title="组件列表">\n') + " " + /*#__PURE__*/_toDisplayString('     <h2 icon="fa-solid fa-expand">卡片1</h2>\n') + " " + /*#__PURE__*/_toDisplayString('     <ss-card><p>你好世界！</p></ss-card>\n') + " " + /*#__PURE__*/_toDisplayString('     <h2>卡片2</h2>\n') + " " + /*#__PURE__*/_toDisplayString('     <ss-card><p>你好世界！</p></ss-card>\n') + " " + /*#__PURE__*/_toDisplayString(' </bc-scrolltab>'))
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-table-columns" }, "切换标签卡", -1))
const _hoisted_44 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "这是个来自古老的 Stapxs Tool Box 的设置页面风格", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 这才是正统的标签卡（Tab）组件，用来切换显示不同的内容。 ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "可选参数", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "title"),
    /*#__PURE__*/_createTextVNode(" ：标签卡列表的标题。如果存在将会显示在标签卡列表的左边，同时所有选项将会右对齐显示。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "selected"),
    /*#__PURE__*/_createTextVNode(" ：标签卡被点击的回调，如果需要的话可以进行一些切换附加操作。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "icon"),
    /*#__PURE__*/_createTextVNode(" ：标签项的图标。使用 Font Awesome 名称。你需要把它添加在每个正文的 DIV 上，在有图标的时候优先显示图标。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "name"),
    /*#__PURE__*/_createTextVNode(" : 「必填」标签项的名字。你需要把它添加在每个正文的 DIV 上。")
  ])
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "示例", -1))
const _hoisted_50 = { class: "view-space" }
const _hoisted_51 = { style: {"display":"flex"} }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { name: "成员" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { name: "公告" }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { icon: "fa-solid fa-face-laugh-squint" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { icon: "fa-solid fa-heart" }, null, -1))
const _hoisted_56 = {
  name: "账号",
  style: {"height":"300px","overflow-y":"scroll"}
}
const _hoisted_57 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "在 Tab 切换的时候，如果 Tab 下的内容可以滚动；bc-tab 将会把内容滚回顶部（如果在这之前滚动到了其他位置）。", -1))
const _hoisted_59 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://secure.gravatar.com/avatar/75c55a45cadac8669a1c5e4943cda5ce?s=330&r=G",
  class: "card-2",
  style: {"width":"3rem","height":"3rem","border-radius":"100%"}
}, null, -1))
const _hoisted_61 = { style: {"display":"flex","flex-direction":"column","margin-left":"20px"} }
const _hoisted_62 = { style: {"font-weight":"bold","color":"var(--color-main)"} }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.8rem","color":"var(--colr-font-2)"} }, "example@outlook.com", -1))
const _hoisted_64 = {
  class: "form-demo",
  style: {"margin":"0"}
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "昵称", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "邮箱", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "公开显示邮箱"),
  /*#__PURE__*/_createElementVNode("label", { class: "ss-switch" }, [
    /*#__PURE__*/_createElementVNode("input", { type: "checkbox" }),
    /*#__PURE__*/_createElementVNode("div", { class: "card-2" }, [
      /*#__PURE__*/_createElementVNode("div")
    ])
  ])
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "密码", -1))
const _hoisted_69 = {
  class: "form-demo",
  style: {"margin":"0"}
}
const _hoisted_70 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("在 "),
  /*#__PURE__*/_createElementVNode("code", null, "0.2.5"),
  /*#__PURE__*/_createTextVNode(" 版本及以后，你可以在 Tab 元素上使用 "),
  /*#__PURE__*/_createElementVNode("code", null, "v-if"),
  /*#__PURE__*/_createTextVNode(" 来隐藏整个选项。")
], -1))
const _hoisted_72 = {
  class: "ss-card",
  style: {"background":"var(--color-card-1)","padding":"15px 20px"}
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "显示功能", -1))
const _hoisted_74 = { class: "ss-switch" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_76 = {
  key: 0,
  name: "功能"
}
const _hoisted_77 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("你可以给 ss-tab 传递 "),
  /*#__PURE__*/_createElementVNode("code", null, "@selected"),
  /*#__PURE__*/_createTextVNode(" 方法来执行切换回调，需要注意的是在 ss-tab 被加载完成时此方法也会被触发。")
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code card-2" }, [
  /*#__PURE__*/_createElementVNode("code", null, /*#__PURE__*/_toDisplayString('<bc-tab title="设置" @selected="closeMenu">\n') + " " + /*#__PURE__*/_toDisplayString('    <ss-card name="账号">这是账号设置</ss-card>\n') + " " + /*#__PURE__*/_toDisplayString('    <ss-card name="界面">这是界面设置</ss-card>\n') + " " + /*#__PURE__*/_toDisplayString('    <ss-card name="功能">这是功能设置</ss-card>\n') + " " + /*#__PURE__*/_toDisplayString('    <ss-card name="高级">这是高级设置</ss-card>\n') + " " + /*#__PURE__*/_toDisplayString('</bc-tab>\n') + " " + /*#__PURE__*/_toDisplayString('<div style="display: flex;">\n') + " " + /*#__PURE__*/_toDisplayString('    <bc-tab style="margin-top: 20px;flex: 1;">\n') + " " + /*#__PURE__*/_toDisplayString('        <div name="成员"></div>\n') + " " + /*#__PURE__*/_toDisplayString('        <div name="公告"></div>\n') + " " + /*#__PURE__*/_toDisplayString('    </bc-tab>\n') + " " + /*#__PURE__*/_toDisplayString('    <bc-tab style="margin-top: 20px;flex: 1;">\n') + " " + /*#__PURE__*/_toDisplayString('        <div icon="fa-solid fa-face-laugh-squint"></div>\n') + " " + /*#__PURE__*/_toDisplayString('        <div icon="fa-solid fa-heart"></div>\n') + " " + /*#__PURE__*/_toDisplayString('    </bc-tab>\n') + " " + /*#__PURE__*/_toDisplayString('</div>'))
], -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-window-maximize" }, "弹窗", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 这是全局弹窗组件，它将显示一个最上层的弹窗，你可以使用它来显示一些重要的信息。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 这个组件可以担任各种页面内弹窗的功能，甚至可以用来显示全屏的内嵌页面和 Vue 组件等 …… ")
], -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "可选参数", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "bc-popbox", -1))
const _hoisted_84 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "建议把组件放置在页面文档的最底端以防止一些奇怪的排版错误", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "方法", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "$bcui['bc-popbox']", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "add(info: PopInfo)"),
    /*#__PURE__*/_createTextVNode(" ：显示弹窗。参数 "),
    /*#__PURE__*/_createElementVNode("code", null, "info"),
    /*#__PURE__*/_createTextVNode(" 是一个对象，它包含了弹窗的信息，具体内容如下： "),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "title"),
        /*#__PURE__*/_createTextVNode(" : 弹窗的标题。缺省将没有标题栏。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "icon"),
        /*#__PURE__*/_createTextVNode(" : 弹窗的标题栏图标。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "html"),
        /*#__PURE__*/_createTextVNode(" : 弹窗的内容。如果同时存在 "),
        /*#__PURE__*/_createElementVNode("code", null, "template"),
        /*#__PURE__*/_createTextVNode("，则优先使用 "),
        /*#__PURE__*/_createElementVNode("code", null, "html"),
        /*#__PURE__*/_createTextVNode("。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "template"),
        /*#__PURE__*/_createTextVNode(" : 弹窗的内容 Vue 模板组件。你可以直接传递一个组件来嵌入到弹窗中。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "templateValue"),
        /*#__PURE__*/_createTextVNode(" : 模板组件的 props 参数。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "data"),
        /*#__PURE__*/_createTextVNode(" : 模板组件的附加传参，只有一个。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "full"),
        /*#__PURE__*/_createTextVNode(" : 是否填充整个页面。如果为 "),
        /*#__PURE__*/_createElementVNode("code", null, "true"),
        /*#__PURE__*/_createTextVNode("，则弹窗将会填充整个页面。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "button"),
        /*#__PURE__*/_createTextVNode(" : 弹窗的按钮列表，包含以下内容： "),
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("code", null, "fun"),
            /*#__PURE__*/_createTextVNode(" : 按钮的回调方法。")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("code", null, "text"),
            /*#__PURE__*/_createTextVNode(" : 按钮的文本。")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("code", null, "master"),
            /*#__PURE__*/_createTextVNode(" : 按钮是否高亮（显示为主题色）。")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "remove()"),
    /*#__PURE__*/_createTextVNode(" : 移除最前面的一个弹窗。")
  ])
], -1))
const _hoisted_89 = {
  class: "view-space",
  style: {"display":"flex"}
}
const _hoisted_90 = { style: {"display":"flex"} }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当多个弹窗被添加时，他们会被排在下面依次准备被显示（同时界面上会叠加最多三个重叠提示）， 一旦弹窗被添加组件并没有提供移除其中某一个的方法，你可以自己搓反正是个列表（躲", -1))
const _hoisted_92 = { class: "code card-2" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-message" }, "吐司", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 欢迎使用超文本烤箱协议！这是个支持它的吐司组件，你可以在任何地方使用它来显示一个吐司。 ", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "可选参数", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "time"),
    /*#__PURE__*/_createTextVNode(" : 吐司的显示时间（毫秒）。默认为 5000。")
  ])
], -1))
const _hoisted_97 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "建议把组件放置在页面文档的最底端以防止一些奇怪的排版错误", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "方法", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "$bcui['bc-toast']", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "show(info: ToastInfo): number"),
    /*#__PURE__*/_createTextVNode(" ：显示吐司，返回吐司 ID。参数 "),
    /*#__PURE__*/_createElementVNode("code", null, "info"),
    /*#__PURE__*/_createTextVNode(" 是一个对象，它包含了吐司的信息，具体内容如下： "),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "icon"),
        /*#__PURE__*/_createTextVNode(" : 「必填」吐司的图标。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "text"),
        /*#__PURE__*/_createTextVNode(" : 「必填」吐司的文本。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "autoClose"),
        /*#__PURE__*/_createTextVNode(" : 是否在超时后自动关闭。默认 false。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "remove(id: number)"),
    /*#__PURE__*/_createTextVNode(" ：关闭指定 ID 的吐司。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "clear()"),
    /*#__PURE__*/_createTextVNode(" ：关闭所有吐司。")
  ])
], -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "示例", -1))
const _hoisted_103 = {
  class: "view-space",
  style: {"display":"flex"}
}
const _hoisted_104 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "你可以通过给吐司组件添加 css 样式来修改它的位置 ……", -1))
const _hoisted_106 = { class: "code card-2" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-ellipsis" }, "菜单", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 这是一个菜单组件，它可以在任意 DIV 下的任意位置显示一个菜单，同时支持打开时指定显示部分菜单项 （不过不支持多级菜单）。 ", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 菜单的正文有两种设置方式，分别为自动生成和自定义；如果你选择自动生成，你需要按照要求书写正文，可以参考下面的示例。 如果你选择自定义，你可以在正文中自由书写任意内容，但是你需要自己处理菜单项的点击事件。 ", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "可选参数", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "data"),
    /*#__PURE__*/_createTextVNode(" : 菜单显示参数。菜单将根据配置显示，包含如下参数： "),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "show"),
        /*#__PURE__*/_createTextVNode(" : 「必填」是否显示。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "point"),
        /*#__PURE__*/_createTextVNode(" : 「必填」显示的坐标，像是 "),
        /*#__PURE__*/_createElementVNode("code", null, "{ x: 0, y: 0 }"),
        /*#__PURE__*/_createTextVNode("。")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("code", null, "list"),
        /*#__PURE__*/_createTextVNode(" : 要显示的菜单项 ID 字符串列表。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "name"),
    /*#__PURE__*/_createTextVNode(" : 菜单名。全局工具方法需要它，用不着可以不写。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "@close"),
    /*#__PURE__*/_createTextVNode(" : 关闭菜单回调。如果是选择选项导致的关闭，会传递菜单项 ID。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "icon"),
    /*#__PURE__*/_createTextVNode(" : 「自动生成必填」菜单项图标。你需要写在正文的 LI 元素上。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "id"),
    /*#__PURE__*/_createTextVNode(" : 「自动生成必填」菜单项 ID。你需要写在正文的 LI 元素上。")
  ])
], -1))
const _hoisted_112 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" 菜单组件会使用 "),
  /*#__PURE__*/_createElementVNode("code", null, "position: absolute;"),
  /*#__PURE__*/_createTextVNode(" 来覆盖父级 DIV， 为了防止意外的排版错误，建议给菜单组件的父级元素添加 "),
  /*#__PURE__*/_createElementVNode("code", null, "position: relative;"),
  /*#__PURE__*/_createTextVNode("。 ")
], -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "方法", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "$bcui['bc-menu']", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "set(name: string, event: MouseEvent): MenuStatue"),
    /*#__PURE__*/_createTextVNode(" : 根据鼠标点击事件获取指定菜单的显示位置。")
  ])
], -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "示例", -1))
const _hoisted_118 = {
  class: "view-space",
  style: {"display":"flex","flex-direction":"column","position":"relative"}
}
const _hoisted_119 = { class: "menu-view" }
const _hoisted_120 = ["src"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-view-body" }, "您赶紧把 BCUI 做成组件罢！", -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-view-body" }, "啊？什么？听不见 ——", -1))
const _hoisted_124 = ["src"]
const _hoisted_125 = { class: "menu-view-body" }
const _hoisted_126 = ["src"]
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-view-body" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "just-img-b",
    href: "https://www.pixiv.net/artworks/75558054"
  }, " 图片来源，侵权请反馈仓库 issue "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 我只是想告诉你菜单是有毛玻璃效果的 XD ")
], -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", {
    icon: "fa-solid fa-message",
    id: "reply"
  }, "回复"),
  /*#__PURE__*/_createElementVNode("li", {
    icon: "fa-solid fa-clipboard",
    id: "copy"
  }, "复制"),
  /*#__PURE__*/_createElementVNode("li", {
    icon: "fa-solid fa-trash-can",
    id: "delete"
  }, "撤回")
], -1))
const _hoisted_130 = { class: "code card-2" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { icon: "fa-solid fa-square-caret-down" }, "折叠面板", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 这是一个一般路过的折叠面板，它没有什么特殊的。 ", -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "可选参数", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "title"),
    /*#__PURE__*/_createTextVNode(" ：面板的标题")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "icon"),
    /*#__PURE__*/_createTextVNode(" ：面板的图标，使用 Font Awesome 名称。如果不填写值（或者是空字符串），将会显示为点前缀。")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "open"),
    /*#__PURE__*/_createTextVNode(" ：面板是否默认打开，不需要填写值（空字符串）。")
  ])
], -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "示例", -1))
const _hoisted_136 = {
  class: "view-space",
  style: {"display":"flex","flex-direction":"column","position":"relative"}
}
const _hoisted_137 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "这儿什么都没有！", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "折叠面板其实也由 ss-card 卡片构成，所以它同样拥有卡片标题的所有标题样式 XD", -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code card-2" }, [
  /*#__PURE__*/_createElementVNode("code", null, /*#__PURE__*/_toDisplayString('<bc-expander title="折叠面板" icon open>\n') + " " + /*#__PURE__*/_toDisplayString('    <ss-card class="card-1" title="小知识" icon="fa-solid fa-circle-info">\n') + " " + /*#__PURE__*/_toDisplayString('        <span>这儿什么都没有！</span>\n') + " " + /*#__PURE__*/_toDisplayString('    </ss-card>\n') + " " + /*#__PURE__*/_toDisplayString('</bc-expander>\n'))
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ss_card = _resolveComponent("ss-card")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ss_input = _resolveComponent("ss-input")!
  const _component_bc_scrolltab = _resolveComponent("bc-scrolltab")!
  const _component_bc_tab = _resolveComponent("bc-tab")!
  const _component_bc_menu = _resolveComponent("bc-menu")!
  const _component_bc_expander = _resolveComponent("bc-expander")!
  const _component_bc_popbox = _resolveComponent("bc-popbox")!
  const _component_bc_toast = _resolveComponent("bc-toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_bc_scrolltab, { title: "组件列表" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_ss_card, {
          title: "卡片：ss-card",
          icon: ""
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_ss_card, {
              class: "card-1",
              title: "view",
              icon: "fa-solid fa-mountain"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ss_card, {
                    title: "提醒",
                    icon: "fa-solid fa-circle-info",
                    id: "delCard",
                    onRemove: _ctx.removeCard
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["onRemove"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ss_card, {
                      title: "卡片颜色",
                      icon: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ss_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_font_awesome_icon, {
                            style: {"margin-right":"30px"},
                            icon: "fa-solid fa-circle-info"
                          }),
                          _hoisted_13
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_15,
        _createVNode(_component_ss_card, {
          title: "表单",
          icon: ""
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _createVNode(_component_ss_card, {
              class: "card-1",
              title: "view",
              icon: "fa-solid fa-mountain"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ss_card, {
                  title: '用户信息' + (_ctx.name != '' ? '（' + _ctx.name + '）' : ''),
                  icon: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", null, [
                        _hoisted_21,
                        _createVNode(_component_ss_input, {
                          icon: "fa-solid fa-user",
                          type: "text",
                          modelValue: _ctx.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_22,
                        _createVNode(_component_ss_input, {
                          icon: "",
                          value: "example@outlook.com"
                        })
                      ]),
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("code", null, _toDisplayString('    <ss-card title="用户信息" icon>\n') + " " + _toDisplayString('    <div class="form-demo">\n') + " " + _toDisplayString('        <div>\n') + " " + _toDisplayString('            <span>昵称</span>\n') + " " + _toDisplayString('            <input type="text" class="ss-input" value="林小槐">\n') + " " + _toDisplayString('        </div>\n') + " " + _toDisplayString('        <div>\n') + " " + _toDisplayString('            <span>邮箱</span>\n') + " " + _toDisplayString('            <ss-input icon v-model="mail"></ss-input>\n') + " " + _toDisplayString('        </div>\n') + " " + _toDisplayString('        <div>\n') + " " + _toDisplayString('            <span>公开显示邮箱</span>\n') + " " + _toDisplayString('            <label class="ss-switch">\n') + " " + _toDisplayString('                <input type="checkbox">\n') + " " + _toDisplayString('                <div><div></div></div>\n') + " " + _toDisplayString('            </label>\n') + " " + _toDisplayString('        </div>\n') + " " + _toDisplayString('        <div>\n') + " " + _toDisplayString('            <span>密码</span>\n') + " " + _toDisplayString('            <ss-input icon="fa-solid fa-key" type="password"></ss-input>\n') + " " + _toDisplayString('        </div>\n') + " " + _toDisplayString('        <div>\n') + " " + _toDisplayString('            <span>性别</span>\n') + " " + _toDisplayString('            <label class="ss-radio">\n') + " " + _toDisplayString('                <input type="radio" name="f">\n') + " " + _toDisplayString('                <div><div></div></div>\n') + " " + _toDisplayString('            </label>\n') + " " + _toDisplayString('            <span>男</span>\n') + " " + _toDisplayString('            <label class="ss-radio">\n') + " " + _toDisplayString('                <input type="radio" name="f">\n') + " " + _toDisplayString('                <div><div></div></div>\n') + " " + _toDisplayString('            </label>\n') + " " + _toDisplayString('            <span>女</span>\n') + " " + _toDisplayString('            <label class="ss-radio">\n') + " " + _toDisplayString('                <input type="radio" name="f" checked>\n') + " " + _toDisplayString('                <div><div></div></div>\n') + " " + _toDisplayString('            </label>\n') + " " + _toDisplayString('            <span>其他</span>\n') + " " + _toDisplayString('        </div>\n') + " " + _toDisplayString('        <div>\n') + " " + _toDisplayString('            <span>启用版本</span>\n') + " " + _toDisplayString('            <select class="ss-select">\n') + " " + _toDisplayString('                <option value="1">1.0</option>\n') + " " + _toDisplayString('                <option value="2">2.0</option>\n') + " " + _toDisplayString('                <option value="0">rolling</option>\n') + " " + _toDisplayString('            </select>\n') + " " + _toDisplayString('        </div>\n') + " " + _toDisplayString('    </div>\n') + " " + _toDisplayString('</ss-card>'), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_28,
        _createVNode(_component_ss_card, {
          title: "滚动标签卡：bc-scrolltab",
          icon: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ss_card, { class: "card-1" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"margin-right":"30px"},
                    icon: "fa-solid fa-lightbulb"
                  }),
                  _hoisted_30
                ])
              ]),
              _: 1
            }),
            _hoisted_31,
            _hoisted_32,
            _hoisted_33,
            _createVNode(_component_ss_card, {
              class: "card-1",
              style: {"margin":"0 40px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"margin-right":"30px"},
                    icon: "fa-solid fa-circle-info"
                  }),
                  _hoisted_35
                ])
              ]),
              _: 1
            }),
            _hoisted_36,
            _createVNode(_component_ss_card, {
              class: "card-1",
              title: "view",
              icon: "fa-solid fa-mountain"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_bc_scrolltab, { title: "这只是标题" }, {
                    default: _withCtx(() => [
                      _hoisted_38,
                      _createVNode(_component_ss_card, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" 这是一些用来演示的文字，要长长长长长长长一点才能看出效果，最好还能换个行。 ")
                        ]),
                        _: 1
                      }),
                      _hoisted_39,
                      _createVNode(_component_ss_card, null, {
                        default: _withCtx(() => [
                          _hoisted_40,
                          _hoisted_41
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_42
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_43,
        _createVNode(_component_ss_card, {
          title: "切换标签卡：bc-tab",
          icon: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ss_card, { class: "card-1" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"margin-right":"30px"},
                    icon: "fa-solid fa-lightbulb"
                  }),
                  _hoisted_45
                ])
              ]),
              _: 1
            }),
            _hoisted_46,
            _hoisted_47,
            _hoisted_48,
            _hoisted_49,
            _createVNode(_component_ss_card, {
              class: "card-1",
              title: "view",
              icon: "fa-solid fa-mountain"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_bc_tab, { style: {"margin-top":"20px","flex":"1"} }, {
                      default: _withCtx(() => [
                        _hoisted_52,
                        _hoisted_53
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_bc_tab, { style: {"margin-top":"20px","flex":"1"} }, {
                      default: _withCtx(() => [
                        _hoisted_54,
                        _hoisted_55
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_bc_tab, {
                    title: "设置",
                    onSelected: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_ss_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_57, [
                              _createVNode(_component_font_awesome_icon, {
                                style: {"margin-right":"30px"},
                                icon: "fa-solid fa-lightbulb"
                              }),
                              _hoisted_58
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ss_card, { style: {"margin-top":"10px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ss_card, { class: "card-1" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_59, [
                                  _hoisted_60,
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.name), 1),
                                    _hoisted_63
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ss_card, {
                              style: {"margin-top":"10px"},
                              class: "card-1",
                              title: '用户信息' + (_ctx.name != '' ? '（' + _ctx.name + '）' : '')
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", null, [
                                    _hoisted_65,
                                    _createVNode(_component_ss_input, {
                                      classIn: "card-2",
                                      icon: "",
                                      modelValue: _ctx.name,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_66,
                                    _createVNode(_component_ss_input, {
                                      classIn: "card-2",
                                      icon: "",
                                      value: "example@outlook.com"
                                    })
                                  ]),
                                  _hoisted_67,
                                  _createElementVNode("div", null, [
                                    _hoisted_68,
                                    _createVNode(_component_ss_input, {
                                      classIn: "card-2",
                                      icon: "",
                                      type: "password",
                                      value: "123"
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["title"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_ss_card, { name: "界面" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 这是界面设置 "),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _createVNode(_component_font_awesome_icon, {
                                style: {"margin-right":"30px"},
                                icon: "fa-solid fa-lightbulb"
                              }),
                              _hoisted_71
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createElementVNode("label", _hoisted_74, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showFun) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.showFun]
                                ]),
                                _hoisted_75
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.showFun)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            _createVNode(_component_ss_card, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_77, [
                                  _createVNode(_component_font_awesome_icon, {
                                    style: {"margin-right":"30px"},
                                    icon: "fa-solid fa-lightbulb"
                                  }),
                                  _hoisted_78
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ss_card, { name: "高级" }, {
                        default: _withCtx(() => [
                          _createTextVNode("这是高级设置")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSelected"])
                ]),
                _hoisted_79
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_80,
        _createVNode(_component_ss_card, {
          title: "全局弹窗：bc-popbox",
          icon: ""
        }, {
          default: _withCtx(() => [
            _hoisted_81,
            _hoisted_82,
            _createTextVNode(" 这个组件没有组件可选参数，它需要使用代码方式初始化和控制。你只需要在页面上放置一个 "),
            _hoisted_83,
            _createTextVNode(" 组件即可。 "),
            _createVNode(_component_ss_card, {
              class: "card-1",
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_84, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"margin-right":"30px"},
                    icon: "fa-solid fa-circle-info"
                  }),
                  _hoisted_85
                ])
              ]),
              _: 1
            }),
            _hoisted_86,
            _createTextVNode(" 在应用初始化导入组件后，PopBox 的操作方法将被挂载到全局 "),
            _hoisted_87,
            _createTextVNode(" 下，你可以直接使用它来操作弹窗。 "),
            _hoisted_88,
            _createVNode(_component_ss_card, {
              class: "card-1",
              title: "view",
              icon: "fa-solid fa-mountain"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(_component_ss_card, {
                    title: "操作",
                    icon: "",
                    style: {"width":"350px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addPop && _ctx.addPop(...args))),
                          style: {"padding":"5px 20px","margin":"10px auto"}
                        }, "显示弹窗")
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ss_card, {
                    title: "样式",
                    icon: "fa-solid fa-mountain"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_91
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("code", null, _toDisplayString('const popBox = getCurrentInstance()?.appContext.config.globalProperties.$bcui[\'bc-popbox\']\n') + " " + _toDisplayString('if(popBox) {\n') + " " + _toDisplayString('   const popInfo = {\n') + " " + _toDisplayString('       title: \'你好啊！\',\n') + " " + _toDisplayString('       icon: \'fa-solid fa-smile\',\n') + " " + _toDisplayString('       html: \'<p>这是一段文字</p>\',\n') + " " + _toDisplayString('       button: [\n') + " " + _toDisplayString('           {\n') + " " + _toDisplayString('               text: \'关闭\',\n') + " " + _toDisplayString('               master: true,\n') + " " + _toDisplayString('               fun: () => this.popBox.remove()\n') + " " + _toDisplayString('           }\n') + " " + _toDisplayString('       ]\n') + " " + _toDisplayString('   }\n') + " " + _toDisplayString('   this.popBox.add(popInfo)\n') + " " + _toDisplayString('}'), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_93,
        _createVNode(_component_ss_card, {
          title: "全局吐司：bc-toast",
          icon: ""
        }, {
          default: _withCtx(() => [
            _hoisted_94,
            _hoisted_95,
            _hoisted_96,
            _createVNode(_component_ss_card, {
              class: "card-1",
              style: {"margin-top":"10px","margin":"0 30px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_97, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"margin-right":"30px"},
                    icon: "fa-solid fa-circle-info"
                  }),
                  _hoisted_98
                ])
              ]),
              _: 1
            }),
            _hoisted_99,
            _createTextVNode(" 在应用初始化导入组件后，Toast 的操作方法将被挂载到全局 "),
            _hoisted_100,
            _createTextVNode(" 下，你可以直接使用它来操作吐司。 "),
            _hoisted_101,
            _hoisted_102,
            _createVNode(_component_ss_card, {
              class: "card-1",
              title: "view",
              icon: "fa-solid fa-mountain"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_103, [
                  _createVNode(_component_ss_card, {
                    title: "操作",
                    icon: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showToast && _ctx.showToast(...args))),
                          style: {"padding":"5px 20px","margin":"10px auto"}
                        }, "显示吐司"),
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearToast && _ctx.clearToast(...args))),
                          style: {"padding":"5px 20px","margin":"10px auto"}
                        }, "清空吐司")
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ss_card, {
                    style: {"flex":"1"},
                    title: "样式",
                    icon: "fa-solid fa-mountain"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_105
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("code", null, _toDisplayString('const toast = getCurrentInstance()?.appContext.config.globalProperties.$bcui[\'bc-toast\']\n') + " " + _toDisplayString('if(toast) {\n') + " " + _toDisplayString('   const toastInfo = {\n') + " " + _toDisplayString('       icon: \'fa-solid fa-circle-info\',\n') + " " + _toDisplayString('       text: \'这是一条吐司消息\',\n') + " " + _toDisplayString('       autoClose: false\n') + " " + _toDisplayString('   }\n') + " " + _toDisplayString('   this.toast.show(toastInfo)\n') + " " + _toDisplayString('}'), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_107,
        _createVNode(_component_ss_card, {
          title: "菜单：bc-menu",
          icon: ""
        }, {
          default: _withCtx(() => [
            _hoisted_108,
            _hoisted_109,
            _hoisted_110,
            _hoisted_111,
            _createVNode(_component_ss_card, {
              class: "card-1",
              style: {"margin-top":"10px","margin":"0 30px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_112, [
                  _createVNode(_component_font_awesome_icon, {
                    style: {"margin-right":"30px"},
                    icon: "fa-solid fa-mountain"
                  }),
                  _hoisted_113
                ])
              ]),
              _: 1
            }),
            _hoisted_114,
            _createTextVNode(" 在应用初始化导入组件后，Menu 的工具方法将被挂载到全局 "),
            _hoisted_115,
            _createTextVNode(" 下，你可以使用它们来简化一些操作。 "),
            _hoisted_116,
            _hoisted_117,
            _createVNode(_component_ss_card, {
              class: "card-1",
              title: "view",
              icon: "fa-solid fa-mountain"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_118, [
                  _createVNode(_component_ss_card, { class: "menu-view-bg" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", {
                          onContextmenu: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showMenu && _ctx.showMenu(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("img", {
                            class: "hd",
                            src: require('../assets/lama.jpg')
                          }, null, 8, _hoisted_120),
                          _createVNode(_component_ss_card, { class: "card-1" }, {
                            default: _withCtx(() => [
                              _hoisted_121
                            ]),
                            _: 1
                          })
                        ], 32),
                        _createElementVNode("div", {
                          onContextmenu: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.showMenu($event, true)), ["prevent"]))
                        }, [
                          _hoisted_122,
                          _createVNode(_component_ss_card, { class: "card-1" }, {
                            default: _withCtx(() => [
                              _hoisted_123
                            ]),
                            _: 1
                          })
                        ], 32),
                        _createElementVNode("div", {
                          onContextmenu: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showMenu && _ctx.showMenu(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("img", {
                            class: "hd",
                            src: require('../assets/lama.jpg')
                          }, null, 8, _hoisted_124),
                          _createVNode(_component_ss_card, { class: "card-1" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("img", {
                                  style: {"width":"150px"},
                                  src: require('../assets/face.gif')
                                }, null, 8, _hoisted_126)
                              ])
                            ]),
                            _: 1
                          })
                        ], 32),
                        _createElementVNode("div", {
                          onContextmenu: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.showMenu($event, true)), ["prevent"]))
                        }, [
                          _hoisted_127,
                          _createVNode(_component_ss_card, { class: "card-1" }, {
                            default: _withCtx(() => [
                              _hoisted_128
                            ]),
                            _: 1
                          })
                        ], 32)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_bc_menu, {
                    data: _ctx.menuStatue,
                    onClose: _ctx.closeMenu,
                    name: "demo-menu"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_129
                    ]),
                    _: 1
                  }, 8, ["data", "onClose"])
                ]),
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("code", null, _toDisplayString('<div @contextmenu.prevent="showMenu"></div>\n') + " " + _toDisplayString('<bc-menu :data="menuStatue" @close="closeMenu" name="demo-menu">\n') + " " + _toDisplayString('    <ul>\n') + " " + _toDisplayString('        <li icon="fa-solid fa-message" id="reply">回复</li>\n') + " " + _toDisplayString('        <li icon="fa-solid fa-clipboard" id="copy">复制</li>\n') + " " + _toDisplayString('        <li icon="fa-solid fa-trash-can" id="delete">撤回</li>\n') + " " + _toDisplayString('    </ul>\n') + " " + _toDisplayString('</bc-menu>\n') + " " + _toDisplayString('\n') + " " + _toDisplayString('showMenu(event: Event, isMe = false) {\n') + " " + _toDisplayString('    const info = this.menu.set(\'demo-menu\', event as MouseEvent)\n') + " " + _toDisplayString('    info.list = !isMe ? [\'reply\', \'copy\'] : [\'delete\', \'copy\']\n') + " " + _toDisplayString('    this.menuStatue = info\n') + " " + _toDisplayString('},\n') + " " + _toDisplayString('closeMenu(id: string) {\n') + " " + _toDisplayString('    this.menuStatue.show = false\n') + " " + _toDisplayString('    if(id) {\n') + " " + _toDisplayString('        this.toast.show({\n') + " " + _toDisplayString('            icon: \'fa-solid fa-circle-info\',\n') + " " + _toDisplayString('            text: `${id} 被点击了。`,\n') + " " + _toDisplayString('            autoClose: true\n') + " " + _toDisplayString('        })\n') + " " + _toDisplayString('    }\n') + " " + _toDisplayString('}'), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_131,
        _createVNode(_component_ss_card, {
          title: "折叠面板：bc-expander",
          icon: ""
        }, {
          default: _withCtx(() => [
            _hoisted_132,
            _hoisted_133,
            _hoisted_134,
            _hoisted_135,
            _createVNode(_component_ss_card, {
              class: "card-1",
              title: "view",
              icon: "fa-solid fa-mountain"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_136, [
                  _createVNode(_component_bc_expander, {
                    title: "折叠面板",
                    icon: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ss_card, {
                        class: "card-1",
                        style: {"margin-top":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_137, [
                            _createVNode(_component_font_awesome_icon, {
                              style: {"margin-right":"30px"},
                              icon: "fa-solid fa-circle-info"
                            }),
                            _hoisted_138
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_bc_expander, {
                    title: "折叠面板",
                    icon: "",
                    open: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ss_card, {
                        class: "card-1",
                        title: "小知识",
                        icon: "fa-solid fa-circle-info"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_139
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_140
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_bc_popbox),
    _createVNode(_component_bc_toast, { time: 5000 })
  ], 64))
}